var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "730",
        persistent: "",
        "no-click-animation": "",
        scrollable: "",
        "overlay-color": "grey-500",
      },
      model: {
        value: _vm.cafDialog,
        callback: function ($$v) {
          _vm.cafDialog = $$v
        },
        expression: "cafDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-700--text font-weight-semibold",
                    },
                    [_vm._v("Cargar folios para " + _vm._s(_vm.type))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-3",
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.$emit("update:cafDialog", false),
                                    _vm.clearInput()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "py-4" },
            [
              _c(
                "v-row",
                { attrs: { align: "center", "no-gutters": "" } },
                [
                  _c("v-col", { staticClass: "pa-0", attrs: { cols: "3" } }, [
                    _c("img", {
                      attrs: {
                        src: require(`@/assets/backgrounds/modal-folios-upload.svg`),
                        height: 230,
                      },
                    }),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "pr-0 pl-15 pt-0", attrs: { cols: "9" } },
                    [
                      _vm.$store?.state?.auth?.account?.country === "CL"
                        ? _c(
                            "div",
                            { staticClass: "mb-3" },
                            [
                              _c(
                                "v-alert",
                                {
                                  staticClass:
                                    "inf-alert-blue green-500--text rounded-md mt-4",
                                  attrs: {
                                    "min-height": 45,
                                    "max-height": 95,
                                    dense: "",
                                    text: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex pa-0 my-1" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: "green-500",
                                            size: "22",
                                          },
                                        },
                                        [_vm._v("mdi-information-outline")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ml-4 text-description",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "body-2",
                                              staticStyle: {
                                                "line-height": "14px",
                                              },
                                            },
                                            [
                                              _vm.type === "timbraje"
                                                ? [
                                                    _vm._v(
                                                      " Los folios cargados serán de "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "uso exclusivo para timbraje."
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [_vm._v("Factura X")]
                                                    ),
                                                    _vm._v(
                                                      " empleará los folios cargados para "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "asignar numeración a los documentos."
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "d-block mt-3 body-1 grey-700--text font-weight-bold mb-2",
                                },
                                [_vm._v("Archivo de folios (CAF)")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "file-drop-area",
                                  class: { "drag-over": _vm.isDragging },
                                  on: {
                                    dragover: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onDragOver.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    dragleave: _vm.onDragLeave,
                                    drop: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onDrop.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  !_vm.newCaf.caf
                                    ? _c("v-file-input", {
                                        key: `${!_vm.newCaf.caf?.length}-${
                                          _vm.resetFileInput
                                        }`,
                                        ref: "newCaf",
                                        staticClass: "ml-n1 custom-file",
                                        style: `z-index: 10; border-color: ${
                                          _vm.$v.newCaf.caf.$error ||
                                          _vm.cafFileType
                                            ? "red"
                                            : ""
                                        }`,
                                        attrs: {
                                          error: _vm.$v.newCaf.caf.$error,
                                          type: "file",
                                          accept: ".xml",
                                          "background-color": "transparent",
                                          height: 50,
                                          "hide-details": "",
                                          solo: "",
                                          flat: "",
                                          chips: "",
                                        },
                                        on: { change: _vm.handlerFile },
                                        model: {
                                          value: _vm.$v.newCaf.caf.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.newCaf.caf,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression: "$v.newCaf.caf.$model",
                                        },
                                      })
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      class: {
                                        "custom-border": !!_vm.newCaf.caf,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-center justify-center custom-text-file",
                                          staticStyle: {
                                            position: "relative",
                                            "z-index": "0",
                                          },
                                        },
                                        [
                                          !_vm.newCaf.caf
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-9 d-flex align-center",
                                                  staticStyle: {
                                                    "margin-top": "-68px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "cols-1 d-flex",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            size: "30",
                                                            color: "grey-700",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-cloud-upload-outline"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "mx-auto transparent",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-block body-1 grey-700--text font-weight-medium",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Haz click para seleccionar un archivo"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-block body-2 grey-500--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "o arrastra el archivo aquí (xml)"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center col-12 mt-1",
                                                },
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      staticStyle: {
                                                        "max-width": "60%",
                                                      },
                                                      attrs: {
                                                        small: "",
                                                        label: "",
                                                        color: "green-100",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-inline-block text-truncate grey-900--text",
                                                          staticStyle: {
                                                            "max-width": "100%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.cafNameFile
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        text: "",
                                                        color: "grey-200",
                                                        ripple: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          ;(_vm.newCaf.caf =
                                                            null),
                                                            (_vm.cafNameFile =
                                                              null),
                                                            (_vm.isValidateDate = false)
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { size: "18" },
                                                        },
                                                        [_vm._v("mdi-delete")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        { staticClass: "px-0 pt-0", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "grey-500--text body-1" }, [
                            _vm._v("Tipo de documento"),
                          ]),
                          _c("v-autocomplete", {
                            attrs: {
                              error: _vm.$v.newCaf.document_type.$error,
                              label: "Selecciona",
                              items: _vm.documentTypesList.filter(
                                ({ country }) =>
                                  country ==
                                  _vm.$store?.state?.auth?.account?.country
                              ),
                              "item-value": "id",
                              "item-text": "name",
                              "menu-props": {
                                overflowY: true,
                                transition: "slide-y-transition",
                              },
                              height: "30",
                              "single-line": "",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "font-weight-regular" },
                                      [_vm._v(_vm._s(data.item.name))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.$v.newCaf.document_type.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.newCaf.document_type,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.newCaf.document_type.$model",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.$store?.state?.auth?.account?.country !== "CL"
                        ? _c(
                            "v-col",
                            { staticClass: "px-0 pt-0", attrs: { cols: "4" } },
                            [
                              _c(
                                "span",
                                { staticClass: "grey-500--text body-1" },
                                [_vm._v("Serie")]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.newCaf.series.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.newCaf.series.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.newCaf.series,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.newCaf.series.$model",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "span",
                        {
                          staticClass:
                            "mt-2 d-block font-weight-regular grey-500--text body-1",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mt-n1",
                              attrs: {
                                size: "16",
                                left: "",
                                color: "grey-700",
                              },
                            },
                            [_vm._v("mdi-pound-box-outline")]
                          ),
                          _vm._v(_vm._s(_vm.$t("generals.Folios")) + ":"),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pl-0 pr-1", attrs: { cols: "5" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.newCaf.start.$error,
                                  prefix: "Desde",
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "64",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.newCaf.start.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.newCaf.start, "$model", $$v)
                                  },
                                  expression: "$v.newCaf.start.$model",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pl-2 pr-0" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.newCaf.end.$error,
                                  prefix: "Hasta",
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "64",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.newCaf.end.$model,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.$v.newCaf.end, "$model", $$v)
                                  },
                                  expression: "$v.newCaf.end.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.newCaf.caf
                ? _c(
                    "v-col",
                    { staticClass: "px-0" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-block mt-3 body-1 grey-700--text font-weight-bold",
                        },
                        [_vm._v("Información del CAF")]
                      ),
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c("v-col", { attrs: { cols: "7" } }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center mt-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "16",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-file-document-outline")]
                                ),
                                _c("span", { staticClass: "d-block" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-bold mr-2 grey-700--text body-1",
                                    },
                                    [_vm._v("Tipo de documento:")]
                                  ),
                                  _vm.folios.type
                                    ? _c("span", { staticClass: "body-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("nameDocumentsType")(
                                              _vm.folios.type
                                            )
                                          )
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "body-2 text--disabled",
                                        },
                                        [_vm._v("Sin especificar")]
                                      ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center mt-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "16",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-domain")]
                                ),
                                _c("span", { staticClass: "d-block" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-bold mr-2 grey-700--text body-1",
                                    },
                                    [_vm._v("Razón social:")]
                                  ),
                                  _vm.folios.business
                                    ? _c("span", { staticClass: "body-2" }, [
                                        _vm._v(_vm._s(_vm.folios.business)),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "body-2 text--disabled",
                                        },
                                        [_vm._v("Sin especificar")]
                                      ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center mt-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "16",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-pound-box-outline")]
                                ),
                                _c("span", { staticClass: "d-block" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-bold mr-2 grey-700--text body-1",
                                    },
                                    [_vm._v("Rango:")]
                                  ),
                                  _vm.folios.startRange && _vm.folios.endRange
                                    ? _c("span", { staticClass: "body-2" }, [
                                        _vm._v(
                                          _vm._s(_vm.folios.startRange) +
                                            " - " +
                                            _vm._s(_vm.folios.endRange)
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "body-2 text--disabled",
                                        },
                                        [_vm._v("Sin especificar")]
                                      ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _c("v-col", [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center mt-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "16",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-calendar-blank")]
                                ),
                                _c("span", { staticClass: "d-block" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-bold mr-2 grey-700--text body-1",
                                    },
                                    [_vm._v("Fecha de aprobación:")]
                                  ),
                                  _vm.folios.date
                                    ? _c("span", { staticClass: "body-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("date")(_vm.folios.date)
                                          )
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "body-2 text--disabled",
                                        },
                                        [_vm._v("Sin especificar")]
                                      ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center mt-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "16",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-file-document")]
                                ),
                                _c("span", { staticClass: "d-block" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-bold mr-2 grey-700--text body-1",
                                    },
                                    [_vm._v("RUT:")]
                                  ),
                                  _vm.folios.rut
                                    ? _c("span", { staticClass: "body-2" }, [
                                        _vm._v(_vm._s(_vm.folios.rut)),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "body-2 text--disabled",
                                        },
                                        [_vm._v("Sin especificar")]
                                      ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "d-flex align-center mt-2" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "16",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-file-multiple-outline")]
                                ),
                                _c("span", { staticClass: "d-block" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "font-weight-bold mr-2 grey-700--text body-1",
                                    },
                                    [_vm._v("Cantidad de folio:")]
                                  ),
                                  _vm.folios.cant
                                    ? _c("span", { staticClass: "body-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$fmt.integer(_vm.folios.cant)
                                          )
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass: "body-2 text--disabled",
                                        },
                                        [_vm._v("Sin especificar")]
                                      ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "px-5 py-2" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { outlined: "" },
                  on: {
                    click: function ($event) {
                      _vm.$emit("update:cafDialog", false), _vm.clearInput()
                    },
                  },
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "grey-900",
                    loading: _vm.loadingCreateCaf,
                    disabled: _vm.isValidateDate,
                  },
                  on: { click: _vm.createNumbering },
                },
                [_vm._v("Cargar folios")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }